
export function incrementAlphaNumericString(str){
  return str.replace(/(\d+)/, (match) => {
    let size = match.length;
    return ("0".repeat(size)+(++match)).substr(-size)
  })
}

export function convertArrToJSON(array, key){
  let obj = {};
  for(let i = 0; i < array.length; i++){
    obj[array[i][key]] = array[i]
  }
  return obj
}

/* Sorting vectorArray based on scalarArray */
export function sortVectorArray(scalarArray, vectorArray, key){
  return vectorArray.sort((a, b) => scalarArray.indexOf(a[key]) - scalarArray.indexOf(b[key]) );
}
